/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import BossDialog from "../../../components/BossDialog";
import { EditPageHeader } from "../../../components/EditPageHeader";
import RoundButton from "../../../framework/forms/helpercomponents/buttons/RoundButton";
import { ImageCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import { LiveMatchEditForm } from "./LiveMatchEditForm";

const getMatchKey = (match) =>
  match?.id ?? match?._id ?? `${match?.teamA?.name ?? ""}-${match?.teamB?.name ?? ""}-${match?.dateTimeGMT ?? ""}`;

const normalizeMatch = (match = {}) => ({
  ...match,
  teamA: {
    ...(match.teamA ?? {}),
    name: match.teamA?.name ?? match.teamInfo?.[0]?.name ?? match.TeamA ?? "",
    img: match.teamA?.img ?? match.teamInfo?.[0]?.img ?? match.TeamAPosterUrl ?? "",
  },
  teamB: {
    ...(match.teamB ?? {}),
    name: match.teamB?.name ?? match.teamInfo?.[1]?.name ?? match.TeamB ?? "",
    img: match.teamB?.img ?? match.teamInfo?.[1]?.img ?? match.TeamBPosterUrl ?? "",
  },
  teams: match.teams ?? [match.teamA?.name ?? match.TeamA ?? "", match.teamB?.name ?? match.TeamB ?? ""],
  teamInfo: match.teamInfo ?? [
    { name: match.teamA?.name ?? match.TeamA ?? "", img: match.teamA?.img ?? match.TeamAPosterUrl ?? "" },
    { name: match.teamB?.name ?? match.TeamB ?? "", img: match.teamB?.img ?? match.TeamBPosterUrl ?? "" },
  ],
  matchType: match.matchType ?? match.Type?.Description ?? "",
  venue: match.venue ?? match.Venue ?? "",
  dateTimeGMT: match.dateTimeGMT ?? "",
});

const DateTimeCell = (cellProps) => (
  <td>
    {cellProps.dataItem?.dateTimeGMT ? moment(cellProps.dataItem.dateTimeGMT).format("DD MMM YYYY HH:mm") : ""}
  </td>
);

const SportsEventMatchesDialog = (props) => {
  const [matchList, setMatchList] = useState([]);
  const [showMatchEditForm, setShowMatchEditForm] = useState(false);
  const [editMatchItem, setEditMatchItem] = useState({});

  useEffect(() => {
    setMatchList((props.matches ?? []).map(normalizeMatch));
  }, [props.matches]);

  const onEditMatch = (match) => {
    setEditMatchItem(normalizeMatch(match));
    setShowMatchEditForm(true);
  };

  const onSubmitMatch = (updatedMatch) => {
    const normalized = normalizeMatch(updatedMatch);
    const updatedList = matchList.map((item) =>
      getMatchKey(item) === getMatchKey(normalized) ? normalized : item
    );

    setMatchList(updatedList);
    props.onChange?.(updatedList);
  };

  const MatchCommandCell = (cellProps) => (
    <div className="mt-1" style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <RoundButton
        icon={"pencil"}
        title={"Edit Match"}
        btnColor={"info"}
        onClick={() => onEditMatch(cellProps.dataItem)}
      />
    </div>
  );

  return (
    <>
      <BossDialog
        title={`Matches (${matchList.length})`}
        onClose={props.onClose}
        width={"85%"}
      >
        <EditPageHeader showTitle={false} showSaveButton={false} onCancel={props.onClose} />

        <div className="mt-2 mb-2">
          <span style={{ color: "#666", fontSize: "13px" }}>
            {matchList.length === 0 ? "No matches available." : "Edit any match here before saving the tournament."}
          </span>
        </div>

        <Grid
          data={matchList}
          dataItemKey="id"
          resizable={true}
          style={{ height: "55vh" }}
        >
          <GridColumn cell={MatchCommandCell} width={"70px"} />
          <GridColumn field="teamA.img" title={"Team A Img"} width={"90px"} cell={ImageCell} />
          <GridColumn field="teamB.img" title={"Team B Img"} width={"90px"} cell={ImageCell} />
          <GridColumn field="teamA.name" title={"Team A"} width={"180px"} />
          <GridColumn field="teamB.name" title={"Team B"} width={"180px"} />
          <GridColumn field="dateTimeGMT" title={"Date Time"} width={"180px"} cell={DateTimeCell} />
          <GridColumn field="matchType" title={"Match Type"} width={"120px"} />
          <GridColumn field="venue" title={"Venue"} width={"220px"} />
        </Grid>
      </BossDialog>

      {showMatchEditForm && (
        <LiveMatchEditForm
          item={editMatchItem}
          selectedTournament={props.selectedTournament}
          localOnly={true}
          onLocalSubmit={onSubmitMatch}
          cancelEdit={() => setShowMatchEditForm(false)}
        />
      )}
    </>
  );
};

export default SportsEventMatchesDialog;
